import React from 'react';
import ReactDOM from 'react-dom';
// import Tilt from "react-parallax-tilt";

import classes from './Modal.module.css';

const Backdrop = props => {
  return <div className={classes.backdrop} onClick={props.onClose} />;
};

const ModalOverlay = props => {
  return (
    <div style={{ background: props.onColor }} className={classes.modal}>
      <div className={classes.content}>{props.children}</div>
    </div>
  );
};

const portalElement = document.getElementById('overlays');

const Modal = props => {
  return (
    <>
      {ReactDOM.createPortal(
        <Backdrop onClose={props.onClose} />,
        portalElement
      )}
      <div className={classes.container}>
        {ReactDOM.createPortal(
          <ModalOverlay onColor={props.onColor}>{props.children}</ModalOverlay>,
          portalElement
        )}
      </div>
    </>
  );
};

export default Modal;
